import { render, staticRenderFns, recyclableRender, components } from "./noveltyItem.vue?vue&type=template&id=3f53b9ec&scoped=true&"
var renderjs
import script from "./noveltyItem.vue?vue&type=script&lang=js&"
export * from "./noveltyItem.vue?vue&type=script&lang=js&"
import style0 from "./noveltyItem.vue?vue&type=style&index=0&id=3f53b9ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f53b9ec",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/merchant/merchatCenter/noveltyManger/noveltyItem.vue"
export default component.exports